import React from "react";
import { Field, FieldArray } from "formik";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { FormCheckbox } from "../../../../../components/ui";
import { IPaymentCard } from "../../../../../api/paymentCards/index.types";
import { useAdminProviderDataContext } from "../../../../../context";
import { STATUS_COLORS_OPACITY } from "../../../../../constants";

interface IProps {
  payment_cards: IPaymentCard[];
  setSelectedCardId: (card_id: number) => void;
}

const TableBody: React.FC<IProps> = ({ payment_cards, setSelectedCardId }) => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  const { banned_account } = useSelector((state) => state.customer.mainData.data);
  const isDisabledByBunReason = !!banned_account?.field_values_before_bun?.payment_cards?.length;

  const handleClickUsageCount = (card_id: number) => setSelectedCardId(card_id);

  return (
    <tbody>
      <FieldArray
        name="payment_cards"
        render={() => {
          return payment_cards.map((card, index) => (
            <Box
              component="tr"
              key={card.id}
              sx={{
                ...(card.def && {
                  "& td": {
                    backgroundColor: "#04dd0747 !important",
                  },
                }),
                ...(!!card.used_times && {
                  "& td": {
                    backgroundColor: `${STATUS_COLORS_OPACITY.tango} !important`,
                  },
                  "& .usedTimes": {
                    backgroundColor: `${STATUS_COLORS_OPACITY.tango} !important`,
                    cursor: "help !important",
                    "&:hover": {
                      background: "rgba(128, 128, 128, 0.4) !important",
                    },
                  },
                }),
              }}
            >
              <td>{card.id}</td>
              <td>{card.brand}</td>
              <td
                className={card.used_times ? "usedTimes" : ""}
                onClick={() => !!card.used_times && handleClickUsageCount(card.id)}
              >
                {card.used_times}
              </td>
              <td>{card.brand === "paypal" ? card.name : card.last4}</td>
              <td>
                <Field
                  name={`payment_cards.${index}.active`}
                  label="Active"
                  placeholder="Active"
                  component={FormCheckbox}
                  disabled={!allowed_features.chane_payment_card_data || isDisabledByBunReason}
                />
              </td>
              <td>
                <Field
                  label="Default"
                  placeholder="Default"
                  component={FormCheckbox}
                  name={`payment_cards.${index}.def`}
                  disabled={!allowed_features.chane_payment_card_data || isDisabledByBunReason}
                />
              </td>
              <td>{card.fingerprint}</td>
              <td>{card.card_token}</td>
            </Box>
          ));
        }}
      />
    </tbody>
  );
};

export default TableBody;
